export default __webpack_public_path__ + "static/media/library-ico.f4d19070.svg";